export default __webpack_public_path__ + "static/media/116-curacao.ab7f1414.svg";